module.exports = __webpack_public_path__ + "img/Arma 3 Unit Newfound Pioneer Corps Modpack step 4.4d4a149e.webp";